import { Row, Column, Caption } from 'gatsby-theme-carbon/src/components/Grid';
import img1 from "../../../../src/visuals/design/ux_6_1_eg.png";
import img2 from "../../../../src/visuals/design/ux_6_2_eg.png";
import img3 from "../../../../src/visuals/design/ux_6_3_eg.png";
import { withPrefix } from "gatsby";
import ToolkitRequirement from "../../../../src/components/rms_resources/requirements";
import ToolkitReference from "../../../../src/components/rms_resources/references";
import ToolkitTechnique from "../../../../src/components/rms_resources/techniques";
import ToolkitTopic from "../../../../src/components/rms_resources/topics";
import * as React from 'react';
export default {
  Row,
  Column,
  Caption,
  img1,
  img2,
  img3,
  withPrefix,
  ToolkitRequirement,
  ToolkitReference,
  ToolkitTechnique,
  ToolkitTopic,
  React
};